import Vue from 'vue'
import Antd from 'ant-design-vue'
import App from './App.vue'
import router from './router'
import store from './store/store'
import 'ant-design-vue/dist/antd.css'
import 'babel-polyfill'
import frog from '@/utils/frog'
import { Form, Field, Toast, Overlay } from 'vant'
import { GardenIcon } from './common/font'
import EventHub from './common/eventHub'
import moment from 'moment'
import '@vant/touch-emulator'
import '@/utils/flexible'
Vue.config.productionTip = false
Vue.use(Antd)
Vue.use(frog)

Vue.use(Form)
Vue.use(Field)
Vue.use(Toast)
Vue.use(Overlay)

Vue.component('garden-icon', GardenIcon)

Vue.prototype.$bus = EventHub
Vue.prototype.$moment = moment

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
